exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.question-btn[data-v-485425b0]{\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #eef8fc;\n    border: 1px solid #dbdbdb;\n    cursor: pointer;\n}\n", ""]);

// exports
